import React, { useEffect } from 'react'
// navigation
import { useNavigate } from 'react-router-dom'
// context, state and remote data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown'
import ChangeEmailLink from 'src/viewLayer/components/shared/HintLinks/ChangeEmailLink'
import PasswordInput from 'src/viewLayer/components/shared/Inputs/PasswordInput'
import { t } from 'src/viewLayer/helpers/translations'

import { useEmailPagePath } from '../../../navigation'
import TrackableButton from '../../shared/TrackableButton'
import BackButton from '../BackButton'
// view components
import CardLayout from '../CardLayout'
import ForgotPasswordLink from './ForgotPasswordLink'
import PasswordImage from './Images/Password.svg'
import {
  ActionsContainer,
  FormContainer,
  InputFrame,
  LoginPasswordPageContainer,
} from './index.styled'

export default function LoginPasswordPage({
  appType,
  captchaFeature,
  email,
  errorKey,
  inProgress,
  isFocused,
  onChange,
  onSubmit,
  password,
  path,
}) {
  const navigate = useNavigate()
  const emailPagePath = useEmailPagePath()
  useTrackPageShown({ appType, pageType: path })
  useEffect(() => {
    if (!email) {
      navigate(emailPagePath, { replace: true })
    }
  }, [email, emailPagePath, navigate])

  const handleOnSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (password.length > 0 && !inProgress) {
      onSubmit()
    }
  }

  return (
    <LoginPasswordPageContainer>
      <CardLayout
        email={email}
        Image={PasswordImage}
        isPasswordPage
        subtitle={email}
        title={t('password.title')}
      >
        <ChangeEmailLink />
        <BackButton path={path} trackingId="backbutton-password-to-email" />
        <FormContainer>
          <form onSubmit={handleOnSubmit}>
            <InputFrame>
              <PasswordInput
                disabled={inProgress}
                errorKey={errorKey}
                isFocused={isFocused}
                onChangeHandler={onChange}
                value={password}
              />
            </InputFrame>
          </form>
          <ForgotPasswordLink email={email} />
          {captchaFeature}
          <ActionsContainer>
            <TrackableButton
              disabled={password.length === 0 || inProgress}
              id="uat-continue-button"
              inProgress={inProgress}
              onClick={handleOnSubmit}
              title="Login button"
              trackingId="password_submit"
            >
              {t('password.button.login')}
            </TrackableButton>
          </ActionsContainer>
        </FormContainer>
      </CardLayout>
    </LoginPasswordPageContainer>
  )
}
